import { configureStore } from '@reduxjs/toolkit';
import moveReducer from '../features/moveSlice';

const store = configureStore({
  reducer: {
    move: moveReducer,
  },
});

export default store;